export function init(){
  cube.$$('.dkt-checkout-primary-button').forEach(button => {
    const isDeliveryTypeNotChecked = cube.$('[name="delivery-type"]') && !cube.$('[name="delivery-type"]:checked');
    const isSalesConditionsNotChecked = (cube.$id('sales-conditions') && !cube.$id('sales-conditions').checked);
    const isErrorMessage = cube.$('.checkout__shipping__home-delivery [name="delivery-type"]:checked') && cube.$('.checkout__shipping__home-delivery .error-message');
    const isAccountError = cube.$('.dkt-checkout-primary-button').classList.contains('error-shipping');

    if (isDeliveryTypeNotChecked || isSalesConditionsNotChecked || isErrorMessage || isAccountError) {
      button.disabled = true;
      button.classList.add('cta-v2--disabled');
    } else {
      button.disabled = false;
      button.classList.remove('cta-v2--disabled');
    }
  });
};



// WEBPACK FOOTER //
// ./src/modules-es5/checkout/state-button-handler.js